import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Button,
} from "@mui/material";
import {
  FaUsers,
  FaFilePdf,
  FaComments,
  FaBell,
  FaChartLine,
  FaCalendarAlt,
  FaJournalWhills,
  FaUserCog,
  FaUserFriends,
  FaCommentsDollar,
} from "react-icons/fa";
import { MdPayment, MdDashboard } from "react-icons/md";
import { Link } from "react-router-dom";
import moment from "moment";
import "./dashboard.css";
import axios from "axios";
import { API_URL } from "../../../config";
import { getCookie } from "../../../function";
import { jwtDecode } from "jwt-decode";

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalArticles: 0,
    pendingArticles: 0,
    totalJournals: 0,
    totalUsers: 0,
  });

  const token = getCookie("token");
  const decodedToken = token ? jwtDecode(token) : null;
  console.log("decodedtoken" , decodedToken.user.id)
  const isAdmin = decodedToken?.user?.userType === "admin";

  const getAdminStats = async () => {
    try {
      const res = await axios.get(`${API_URL}/getArticleStatsAdmin?id=${decodedToken.user.id}`, {
        headers: {
          Authorization: getCookie("token"),
          "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
        },
      });
      const parsedData = JSON.parse(res.data);
      const result = JSON.parse(parsedData.body);
      setStats(result.data);
    } catch (error) {
      console.error("Failed to fetch admin stats:", error);
    }
  };

  useEffect(() => {
    getAdminStats();
  }, []);

  const StatCard = ({ title, value, icon, color, link }) => (
    <Card sx={{ height: "100%", backgroundColor: color, color: "white" }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4">{value}</Typography>
          </Box>
          <Box>{icon}</Box>
        </Box>
        {link && (
          <Button
            component={Link}
            to={link}
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "white",
              color: color,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.9)",
              },
            }}
          >
            View Details
          </Button>
        )}
      </CardContent>
    </Card>
  );

  const QuickAccessCard = ({ title, icon, link, description }) => (
    <Card sx={{ height: "100%", p: 2 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          {icon}
          <Typography variant="h6" sx={{ ml: 2 }}>
            {title}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {description}
        </Typography>
        <Button
          component={Link}
          to={link}
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
        >
          Go to {title}
        </Button>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h4" component="h1">
          {isAdmin ? "Admin Dashboard" : "Account Dashboard"}
        </Typography>
        <Box display="flex" gap={2}>
          <Tooltip title="Notifications">
            <IconButton>
              <FaBell />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {/* Stats Cards */}
        <Grid item xs={12} md={isAdmin ? 3 : 6}>
          <StatCard
            title="Total Invoice"
            value={stats.totalArticles}
            icon={<FaFilePdf size={40} />}
            color="#388e3c"
            link={isAdmin ? "/admin/client-articles" : "/admin/articles"}
          />
        </Grid>
        <Grid item xs={12} md={isAdmin ? 3 : 6}>
          <StatCard
            title="Pending Invoices"
            value={stats.pendingArticles}
            icon={<FaChartLine size={40} />}
            color="#f57c00"
            link={isAdmin ? "/admin/client-articles?status=pending" : "/admin/articles?status=pending"}
          />
        </Grid>

        {isAdmin && (
          <>
            <Grid item xs={12} md={3}>
              <StatCard
                title="Total Publications"
                value={stats.totalJournals}
                icon={<FaJournalWhills size={40} />}
                color="#9c27b0"
                link="/admin/publication"
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <StatCard
                title="Total Users"
                value={stats.totalUsers}
                icon={<FaUserFriends size={40} />}
                color="#1976d2"
                link="/admin/user"
              />
            </Grid>
          </>
        )}

        {/* Quick Access Section */}
        <Grid item xs={12}>
          <Typography variant="h5" mb={2}>
            Quick Access
          </Typography>
        </Grid>

        {isAdmin && (
          <Grid item xs={12} md={4}>
            <QuickAccessCard
              title="Client Management"
              icon={<FaUserFriends size={24} />}
              link="/admin/client"
              description="Manage client accounts, view client details, and handle client-related tasks"
            />
          </Grid>
        )}

        {isAdmin && (
          <Grid item xs={12} md={4}>
            <QuickAccessCard
              title="User"
              icon={<FaUserCog size={24} />}
              link="/admin/user"
              description="Manage user accounts, permissions, and user-related settings"
            />
          </Grid>
        )}

        <Grid item xs={12} md={isAdmin ? 4 : 12}>
          <QuickAccessCard
            title="Calculation"
            icon={<MdPayment size={24} />}
            link="/admin/calculation"
            description="Access calculation tools and manage financial computations"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
